var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.051 5.051c.193-.193.454-.301.727-.301h5.333a.75.75 0 0 0 0-1.5H5.778A2.53 2.53 0 0 0 3.25 5.778v12.444a2.53 2.53 0 0 0 2.528 2.528h12.444a2.53 2.53 0 0 0 2.528-2.528V12.89a.75.75 0 0 0-1.5 0v5.333a1.03 1.03 0 0 1-1.028 1.028H5.778a1.03 1.03 0 0 1-1.028-1.028V5.778c0-.273.108-.534.301-.727M13.917 4c0 .414.335.75.75.75h3.522l-6.72 6.72a.75.75 0 1 0 1.061 1.06l6.72-6.72v3.523a.75.75 0 0 0 1.5 0V4a.75.75 0 0 0-.75-.75h-5.333a.75.75 0 0 0-.75.75",
    clipRule: "evenodd"
  })));
};
export default SvgExternalLink;